import { defineStore } from 'pinia'
const storage = window.localStorage

const USER_KEY = 'UadUser'
const TOKEN_KEY = 'UadToken'

export const useUserStore = defineStore('user', {
  state: () => ({
    user: JSON.parse(storage.getItem(USER_KEY) || '{}'),
    token: storage.getItem(TOKEN_KEY)
  }),
  actions: {
    setToken(token) {
      this.token = token
      storage.setItem(TOKEN_KEY, this.token)
    },
    setUserId(user_id) {
      this.user = Object.assign(this.user, {user_id})
      storage.setItem(USER_KEY, JSON.stringify(this.user))
    },
    setUser(patch) {
      this.user = Object.assign(this.user, patch)
      storage.setItem(USER_KEY, JSON.stringify(this.user))
    },
    login(user, token) {
      this.user = Object.assign({}, user)
      storage.setItem(USER_KEY, JSON.stringify(this.user))
      this.setToken(token)
    },
    logout() {
      this.user = Object.assign({}, {})
      this.token = null
      storage.removeItem(USER_KEY)
      storage.removeItem(TOKEN_KEY)
    }
  },
  getters: {
    getUser: ({user}) => user,
    getToken: ({token}) => token,
    getUserId: ({user}) => user?.user_id || null,
    getEmail: ({user}) => user?.email || null,
    getFirstName: ({user}) => user?.first_name || null,
    getStickyId: ({user}) => user?.sticky_id || null,
    loggedIn: ({token}) => token ? true : false
  }
})